<template>
  <v-autocomplete
    :value="value"
    :disabled="loading"
    :items="items"
    chips
    deletable-chips
    :label="label"
    item-text="description"
    item-value="id"
    :hide-details="hideDetails"
    @change="select"
    return-object
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="clear"
      >
        {{ data.item.code }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item.code }} </v-list-item-title>
        <v-list-item-subtitle
          >{{ data.item.description.replace(data.item.code + " - ", "") }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "RoomPicker",
  props: {
    value: Object,
    label: {
      type: String,
      default: "Zimmer",
    },
    nullValue: {
      type: Object,
      default: null,
    },
    hideDetails: Boolean,
  },
  data() {
    return {
      loading: true,
      items: [],
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      this.items = await this.apiList({ resource: "common/room" });
      this.loading = false;
    },
    clear() {
      this.$emit("input", this.nullValue);
    },
    select($event) {
      this.$emit("input", $event);
    },
  },
  async created() {
    this.getData();
  },
});
</script>
